module.exports = __webpack_public_path__ + "static/media/Wheat_Green.6bf2fac6.svg";